import { render, staticRenderFns } from "./AdminDashRevenue.vue?vue&type=template&id=730985f8&scoped=true"
import script from "./AdminDashRevenue.vue?vue&type=script&lang=js"
export * from "./AdminDashRevenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730985f8",
  null
  
)

export default component.exports